import React, { useEffect, useState, useContext } from 'react';
import { Card, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Chat from './Chat';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import SmartContext from '../../App/context/SmartContext';
import {
  CHAT_CONTACT_TYPES,
  CONTACT_CHAT_TYPE,
} from '../../../shared/utils/constants';
import smarttalkaxios from '../../../smarttalkaxios';

const ChatCard = (props) => {
  const { t, dispatch } = props;
  const context = useContext(SmartContext);
  const { pendencySummary } = context;
  const [selectedChannel, setSelectedChannel] = useState();
  const [selectedUserChatId, setSelectedUserChatId] = useState();

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const [loggedChatUser, setLoggedChatUser] = useState({});
  const [contacts, setContacts] = useState([]);
  const [contactType, setContactType] = useState();

  const loadChatContacts = (selectedChannelId, chatUserId) => {
    showLoading();
    setSelectedChannel(selectedChannelId);
    setSelectedUserChatId(chatUserId);
    if (!selectedChannelId) {
      smarttalkaxios()
        .get(`/contacts/${true}`)
        .then((res) => {
          setContacts(res.data);
          setContactType(CONTACT_CHAT_TYPE.CHANNEL);
          hideLoading();
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    } else {
      smarttalkaxios()
        .get(`/channelcontacts/${selectedChannelId}/${chatUserId}`)
        .then((res) => {
          hideLoading();
          setContacts(res.data);
          setContactType(CONTACT_CHAT_TYPE.STUDENT);
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    }
  };

  const loadChatUser = () => {
    showLoading();
    smarttalkaxios()
      .get('/user')
      .then((res) => {
        setLoggedChatUser(res.data);
        loadChatContacts();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const updateSummaryView = (summaryData) => {
    const updatedContact = [];
    contacts.forEach((contact) => {
      let contactSummary;
      if (contact.type === CHAT_CONTACT_TYPES.COMMUNICATION_CHANNEL) {
        contactSummary = summaryData.find(
          (summary) => summary.recipientId === contact.chatUserId
        );
      } else {
        contactSummary = summaryData.find(
          (summary) => summary.senderId === contact.chatUserId
        );
      }
      updatedContact.push({
        ...contact,
        unreadMessage: contactSummary ? contactSummary.amount : 0,
      });
    });
    setContacts(updatedContact);
  };

  useEffect(() => {
    const { chatSummary } = pendencySummary;
    if (chatSummary) {
      updateSummaryView(chatSummary);
    }
  }, [pendencySummary]);

  useEffect(() => {
    loadChatUser();
  }, []);

  return (
    <Col md={12} lg={12}>
      <Card>
        <Chat
          contacts={contacts}
          currentUser={loggedChatUser}
          loadChatContacts={loadChatContacts}
          contactType={contactType}
          channelId={selectedChannel}
          userChatId={selectedUserChatId}
        />
      </Card>
    </Col>
  );
};

ChatCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ChatCard)
);
